import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class RoomServiceGuard implements CanActivate {
    constructor(private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // Staff (subadmin) sessions store the STAFF's own user record in
        // `userData`, not the apartment owner's — it never carries the
        // apartment's room_service subscription flag, so checking it here
        // incorrectly redirected staff to /no-access even when they held the
        // matching permission. The apartment's actual service list for a
        // staff session lives in `enabledServices` (an array of service keys
        // — confirmed from a real staff-login response: 'club', 'spa',
        // 'laundry', 'room-service', 'restaurant', 'grocery', 'car-rental')
        // set at staff login — so a staff member is only let in if BOTH their
        // own permission (already the reason they see the sidebar link) AND
        // the apartment's own subscription cover this section. There's no
        // separate residential-service key — residential apartments use the
        // same 'room-service' key, matching the same single-flag convention
        // already used for the apartment owner's own room_service field.
        const isStaff = localStorage.getItem('usertype') === 'subadmin';
        if (isStaff) {
            const enabledServicesRaw = localStorage.getItem('enabledServices');
            if (enabledServicesRaw) {
                let enabledServices: string[] = [];
                try { enabledServices = JSON.parse(enabledServicesRaw) || []; } catch { enabledServices = []; }
                if (Array.isArray(enabledServices) && enabledServices.length && !enabledServices.includes('room-service')) {
                    const service = route.data?.['service'] || 'Service Request';
                    this.router.navigate(['/no-access'], { queryParams: { service } });
                    return false;
                }
            }
            return true;
        }

        const data = localStorage.getItem('userData');
        if (data) {
            const user = JSON.parse(data);
            const enabled = user['room_service'];
            if (enabled === 0 || enabled === '0') {
                const service = route.data?.['service'] || 'Service Request';
                this.router.navigate(['/no-access'], { queryParams: { service } });
                return false;
            }
        }
        return true;
    }
}
